import type { B2BEventType, B2BPublicEventCategory } from 'api/requestTypes';

/** Contract order for event-type chips (`ChipGroup`). */
export const B2B_EVENT_TYPE_OPTIONS_ORDER = [
  'PUBLIC',
  'PRIVATE',
  'FREE',
] as const satisfies readonly B2BEventType[];

/** Contract order for public category chips when `eventType === 'PUBLIC'`. */
export const B2B_PUBLIC_EVENT_CATEGORY_OPTIONS_ORDER = [
  'CONCERT',
  'CONFERENCE',
  'WORKSHOP',
  'COMEDY_SHOW',
  'EXHIBITION',
  'SPORT_EVENT',
  'OTHER',
] as const satisfies readonly B2BPublicEventCategory[];

export const b2bEventTypeLabelMessageId = (eventType: B2BEventType) =>
  `b2b.registration.eventType.${eventType}` as const;

export const b2bPublicEventCategoryLabelMessageId = (category: B2BPublicEventCategory) =>
  `b2b.registration.publicCategory.${category}` as const;

/** React Hook Form / API field name for {@link B2BEventType}. */
export const B2B_REGISTRATION_EVENT_TYPE_FIELD_NAME = 'eventType' as const;

/** React Hook Form / API field name for {@link B2BPublicEventCategory} (only when public). */
export const B2B_REGISTRATION_PUBLIC_CATEGORY_FIELD_NAME = 'publicEventCategory' as const;
